<div class="modal-content border-0 bg-transparent text-light modern-theme">
  <!-- Header -->
  <div class="modal-header border-0 p-4 pb-0 d-flex justify-content-between align-items-center">
    <div>
      <h4 class="modal-title fw-bold mb-1">Inventory Database Search</h4>
      <p class="text-light small mb-0">Search the live database by manufacturer and description.</p>
    </div>
    <button 
      type="button" 
      class="close-btn" 
      (click)="closeModalClick()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body p-4 pt-2">
    <!-- Action Bar -->
    <div class="action-bar d-flex align-items-center gap-3 bg-dark-subtle p-3 rounded-3 mb-4 flex-wrap">
      <div class="d-flex align-items-center gap-2 flex-grow-1">
        <label class="text-light fw-bold mb-0 text-nowrap">Manufacturer:</label>
        <ng-select
          [items]="manufacturers"
          [(ngModel)]="manufacturer"
          placeholder="Select Manufacturer"
          class="modern-select flex-grow-1"
          (change)="searchDatabase()"
        ></ng-select>
      </div>
      <div class="d-flex align-items-center gap-2 flex-grow-1">
        <label class="text-light fw-bold mb-0 text-nowrap">Description:</label>
          <input 
          type="text" 
          class="form-control modern-input w-100" 
          placeholder="e.g. 2 WAY HOLSTER" 
          [(ngModel)]="description"
          (keyup.enter)="searchDatabase()"
        />
      </div>
      <button class="btn modern-btn shadow-sm px-4 d-flex align-items-center gap-2" (click)="searchDatabase()" [disabled]="isSearching">
        @if(isSearching) {
          <i class="fa-solid fa-circle-notch fa-spin"></i>
        } @else {
          <i class="fa-solid fa-magnifying-glass"></i>
        }
        Search
      </button>
    </div>

    <!-- Grid Container -->
    <div class="grid-container rounded-3 overflow-hidden shadow-lg" style="height: 500px;">
      <ag-grid-angular
        style="width: 100%; height: 100%;"
        
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        [rowData]="searchResults"
        [overlayLoadingTemplate]="overlayLoadingTemplate"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [animateRows]="true"
        (gridReady)="onGridReady($event)"
        (rowDoubleClicked)="onRowSelected($event)"
      >
      </ag-grid-angular>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer border-0 p-4 pt-0">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="text-light small">
        <i class="fa-solid fa-circle-info me-1"></i>
        Double-click a row to select an item.
      </div>
      <button type="button" class="btn btn-outline-secondary px-4" (click)="closeModalClick()">Close</button>
    </div>
  </div>
</div>

